export default __webpack_public_path__ + "static/media/dark-active-message-icon.aa4e2529.svg";